module.exports = __webpack_public_path__ + "static/media/apportion_example.d50611e103c48713e86f6a267d7437e2.png";